import { render, staticRenderFns } from "./container_depot_detail.vue?vue&type=template&id=958bd334&scoped=true&"
import script from "./container_depot_detail.vue?vue&type=script&lang=js&"
export * from "./container_depot_detail.vue?vue&type=script&lang=js&"
import style0 from "./container_depot_detail.vue?vue&type=style&index=0&id=958bd334&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958bd334",
  null
  
)

export default component.exports